import React from 'react'
import PropTypes from 'prop-types'
import Container from './Container'

const propTypes = {
  children: PropTypes.node,
}

const ArticleLayout = ({ children }) => {
  return (
    <Container>
      <div className="mx-auto relative lg:flex lg:-mx-3 bg-white">
        {children}
      </div>
    </Container>
  )
}

ArticleLayout.propTypes = propTypes

export default ArticleLayout
